import { ApplicationBankStatusGuard } from "./ApplicationBankStatusGuard/ApplicationBankStatusGuard";
import { ApplicationStatusGuard } from "./ApplicationStatusGuard/ApplicationStatusGuard";
import { RoleGuard } from "./RoleGuard/RoleGuard";

/** Общий guard для проверки статусов и ролей.
 * Используется как компонент-обертка для контента:
 * <Guard.ApplicationBankStatus>
 * или
 * <Guard.Role>
 */
export const Guard = {
  Role: RoleGuard,
  ApplicationBankStatus: ApplicationBankStatusGuard,
  ApplicationStatus: ApplicationStatusGuard,
};
